export const roundNumber = (num: number, decimal = 0) => {
  const multiplier = Math.pow(10, decimal)
  return Math.round((num + Number.EPSILON) * multiplier) / multiplier
}
